// @ts-nocheck
import React, { useEffect, useState } from 'react'
import './index.scss'
import {
  FaArrowUp,
  FaArrowDown,
  FaArrowRight,
  FaArrowLeft,
} from 'react-icons/fa'
import { FiKey } from 'react-icons/fi'
import { MdAlarm } from 'react-icons/md'
import { BsBehance, BsMedium } from 'react-icons/bs'

const Projects = () => {
  const [matches, setMatches] = useState(
    window.matchMedia('(min-width: 1200px)').matches
  )

  const [projects, setProjects] = useState([
    {
      id: 0,
      title: 'Virtual Pub',
      description:
        'UX Research (UXR) for a sports spectatorship mobile application',
      keyWords: [
        'Second Screen',
        'Data Visualiztion',
        'Desk Research',
        'Human Factors',
        'Sports Spectating',
        'Data Analysis',
      ],
      time: '2 Months, part-time',
      image: require('../../assets/images/virtual-pub.png'),
      behance: 'https://medium.com/@heshamnasserr/4370ad43a0f6',
    },
    {
      id: 1,
      title: 'Pet Shelter',
      description: 'Conceptual mobile application for a local animal shelter',
      keyWords: [
        'Persona',
        'Prototyping',
        'Usability Testing',
        'Qualitative Research',
        'Competitive Audit',
        'Micro-interactions',
        'Mini Design System',
      ],
      time: '1 Month, part-time',
      image: require('../../assets/images/pet-shelter.png'),
      behance: 'https://www.behance.net/gallery/155665425/Pet-Shelter-App',
    },
    {
      id: 2,
      title: 'Anas Saleh',
      description: 'A website for a professional photographer',
      keyWords: [
        'Web Design',
        'Rapid Prototype',
        'Personal Branding',
        'Slideshow',
        'Micro-interactions',
      ],
      time: '2 Weeks, part-time',
      image: require('../../assets/images/anas.png'),
      behance: 'https://www.behance.net/gallery/156761191/Anas-Saleh-Website',
    },
  ])

  let [selectedProject, setSelectedProject] = useState(0)

  useEffect(() => {
    window
      .matchMedia('(min-width: 1200px)')
      .addListener((e) => setMatches(e.matches))
  }, [])

  let project = projects[selectedProject]

  useEffect(() => {
    console.log('selectedProject')
  }, [selectedProject])

  const openInNewTab = (url) => {
    window.open(url, '_blank', 'noopener,noreferrer')
  }
  return (
    <div className="projects-container">
      <div className="item1">
        <div className="arrows">
          {matches && (
            <FaArrowUp
              className="FaArrowUp"
              onClick={() => {
                setSelectedProject(selectedProject - 1)
                if (selectedProject === 0) {
                  setSelectedProject(2)
                }
              }}
            />
          )}
          {!matches && (
            <FaArrowLeft
              onClick={() => {
                setSelectedProject(selectedProject - 1)
                if (selectedProject === 0) {
                  setSelectedProject(2)
                }
              }}
              style={{ fontSize: '12px', color: '#0f0f0f' }}
            />
          )}
        </div>
        <div className="projects">Project {selectedProject + 1}/3</div>
        <div className="arrows">
          {matches && (
            <FaArrowDown
              onClick={() => {
                setSelectedProject(selectedProject + 1)
                if (selectedProject === 2) {
                  setSelectedProject(0)
                }
              }}
              className="FaArrowUp"
            />
          )}
          {!matches && (
            <FaArrowRight
              onClick={() => {
                setSelectedProject(selectedProject + 1)
                if (selectedProject === 2) {
                  setSelectedProject(0)
                }
              }}
              style={{ fontSize: '12px', color: '#0f0f0f' }}
            />
          )}
        </div>
      </div>
      <div className="item2">
        <div className="project-container">
          <h1 className="project-title">{project.title}</h1>
          <h2 className="project-description">{project.description}</h2>
          <hr />
          <div className="project-keywords-title">
            <FiKey className="FiKey" />
            <span className="project-keywords"> Keywords</span>
          </div>
          <div className="keywords">
            {project.keyWords.map((project) => {
              return (
                <>
                  <div className="keyword">{project}</div>
                </>
              )
            })}
          </div>
          <div className="time">
            <MdAlarm className="MdAlarm" />
            <span className="time-title"> Time</span>
            <div className="time-description">{project.time}</div>
          </div>
        </div>
        <div></div>
      </div>
      <div className="item3">
        <div>
          <img
            // @ts-ignore
            src={project.image}
            alt="portfolio"
            className="project-image"
          />
        </div>
        <div className="center-buttons">
          <div>
            <button
              className="view-in-behance-btn"
              onClick={() => {
                openInNewTab(project.behance)
                console.log('navigate to behance')
              }}
            >
              {project.id === 0 ? (
                <BsMedium className="behanceIcons" />
              ) : (
                <BsBehance className="behanceIcons" />
              )}

              {project.id === 0 ? `VIEW IN MEDIUM` : `VIEW IN BEHANCE`}
            </button>
          </div>
          <div></div>
        </div>
      </div>
    </div>
  )
}

export default Projects
